export default __webpack_public_path__ + "static/media/ITOAM-bothbooked-dark.ef230853.svg";